import React from 'react';

import type { Faq } from './buildFaq.js';

import { RichTextBlock } from '../../../../core/system/rendering/helpers/index.js';
import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';

const ListPageFaq: React.FC<{ faqs: Faq[]; listId: string }> = ({
  faqs,
  listId,
}) => {
  const { trackClickUIElement } = usePulseContext();

  const handleToggle = (e: React.ChangeEvent<HTMLDetailsElement>) => {
    if (e.target.open) {
      trackClickUIElement({
        object: {
          id: `faq:details-${listId}`,
          name: `FAQ element for ${listId}`,
          elementType: 'Button',
        },
      });
    }
  };

  return (
    <div className="faq">
      <h2 className="subheader">FAQ</h2>

      {faqs.map((faq, index) => (
        <details key={`faq-${index}`} onToggle={handleToggle}>
          <summary>
            <RichTextBlock content={faq.question} />
          </summary>
          {faq.answers.map((answer, i) => (
            <RichTextBlock key={`answer-${i}`} content={answer} />
          ))}
        </details>
      ))}
    </div>
  );
};

export default ListPageFaq;
